import { useFlags } from '@atlaskit/flag';
import EditorRemoveIcon from '@atlaskit/icon/glyph/editor/remove';
import ModalDialog from '@atlaskit/modal-dialog';
import { ButtonClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { deletePromotionCode } from '@atlassian/mpac-api-client';
import { log } from '@atlassian/mpac-utils';
import React, { useState } from 'react';
import { ANALYTICS_SUBJECT_ID_DELETE_PROMOTION_CODE } from "../../../../analytics/Events";
import { getFlagForError } from "../../../../utils/FlagUtils";

const DeletePromotionCode = props => {
  const {
    showFlag
  } = useFlags();
  const [isConfirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleOpenModal = () => setConfirmationModalOpen(true);

  const handleCloseModal = () => setConfirmationModalOpen(false);

  const fireAnalyticsEvent = useAnalyticsEvents();

  const handleDeletePromotionCode = async () => {
    setIsLoading(true);
    fireAnalyticsEvent({
      eventType: ButtonClickedEvent,
      actionSubjectId: ANALYTICS_SUBJECT_ID_DELETE_PROMOTION_CODE
    });

    try {
      await deletePromotionCode(props.mpacBaseUrl, props.partnerId, props.promotionId, props.promotionCode);
      handleCloseModal();
      props.onDeletePromotionCode(props.promotionCode);
    } catch (error) {
      showFlag(getFlagForError('delete-promotion-code-flag', 'Deleting the promotion code failed'));
      log.error('PromotionCodes/DeletePromotionCode', "Failed to delete Promotion Code", {
        error
      });
    }

    setIsLoading(false);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    "data-testid": "delete-promotion-code__remove-icon",
    onClick: handleOpenModal
  }, /*#__PURE__*/React.createElement(EditorRemoveIcon, null)), isConfirmationModalOpen && /*#__PURE__*/React.createElement(ModalDialog, {
    actions: [{
      text: 'Cancel',
      appearance: 'subtle',
      onClick: handleCloseModal
    }, {
      text: 'Delete',
      isLoading,
      appearance: 'primary',
      onClick: handleDeletePromotionCode
    }],
    onClose: handleCloseModal,
    heading: "Remove Single-use code"
  }, "Are you sure you want to remove ", props.promotionCode, " ?"));
};

export default DeletePromotionCode;